/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FunctionComponent, useEffect, useState } from "react";
import { IErrorMessage } from "@advapacs/common";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Header from "../../parts/Header";

const UserEmailValidationEmail: FunctionComponent = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<IErrorMessage>();

  useEffect(() => {
    if (token) {
      axios
        .get(`/auth/emailValidation`, {
          params: {
            token,
          },
        })
        .then(() => {})
        .catch((err) => {
          setErrorMessage(err.response.data);
        });
    } else {
      navigate("/NotFound");
    }
  }, [navigate, token]);
  return (
    <>
      <Header expandSidebar />
      <div>
        <div className="auth-container">
          <div className="form-group text-center">
            {!errorMessage ? (
              <>
                <h3 style={{ color: "green" }}>
                  {t(
                    "error_messages.your_email_address_has_been_verified_successfully"
                  )}
                </h3>
              </>
            ) : (
              <h3 style={{ color: "red" }}>
                {t("error_messages.token_invalid")}
              </h3>
            )}
            <button type="button" className="btn" onClick={() => navigate("/")}>
              {t("back_to_home")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserEmailValidationEmail;
